import { makeAutoObservable, toJS } from 'mobx'
import type { IMergeFieldType } from 'entities/Integrations'
import { type IChatbotField } from './type'

export class ChatbotFields {
  private _list: ChatbotField[] = []

  constructor() {
    makeAutoObservable(this)
  }

  setItems = (items: ChatbotField[]) => {
    this._list = items
  }

  syncOrigin(items?: IChatbotField[] | null) {
    this._list = items?.map((item) => new ChatbotField(item)) ?? []
  }

  toJSON(): IChatbotField[] {
    return toJS(this._list.map((item) => item.toJSON()))
  }

  reset() {
    this._list = [new ChatbotField()]
  }

  get list() {
    return this._list
  }
}

export class ChatbotField {
  static Create(item?: IChatbotField) {
    return new ChatbotField(item)
  }

  name = ''
  key = ''
  type: IMergeFieldType = 'text'

  constructor(item?: IChatbotField) {
    if (!!item) this.syncOrigin(item)

    makeAutoObservable(this)
  }

  setKey(key: string) {
    this.key = key
  }

  setName(name: string) {
    this.name = name
  }

  syncOrigin(item?: Partial<IChatbotField> | null) {
    this.name = item?.name ?? this.name
    this.key = item?.key ?? this.key
    this.type = item?.type ?? this.type
  }

  toJSON(): IChatbotField {
    return toJS({
      name: this.name,
      key: this.key,
      type: this.type,
    })
  }

  reset() {
    this.key = ''
    this.name = ''
    this.type = 'text'
  }
}
